/**
 * The StatusLabel tone for an invoice or ticket status (web restyle, 2026-10-28). It keeps each
 * status's meaning: paid is success, void and cancelled are danger, a draft is neutral, and
 * anything still moving (sent, open, approved, invoiced) is info.
 */
import type { StatusTone } from 'src/components/ui/status-label';

export function invoiceStatusTone(status: string): StatusTone {
  switch (status.toUpperCase()) {
    case 'PAID':
      return 'success';
    case 'VOID':
    case 'VOIDED':
    case 'CANCELLED':
      return 'danger';
    case 'DRAFT':
      return 'neutral';
    default:
      return 'info';
  }
}
